<template>

  <div>
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Partner
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-600"></p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow sm:rounded-md sm:overflow-hidden">

          <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div v-if="partners" class="col-span-6 sm:col-span-4">

                <div class="flex items-center gap-x-4 mb-4">
                  <svg @click="checkAllPartners" v-tooltip.top="`Alle auswählen`" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="w-5 h-5 cursor-pointer text-gray-900 hover:text-markencode-blue outline-none">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>

                  <svg @click="uncheckAllPartners" v-tooltip.top="`Alle abwählen`" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="w-5 h-5 cursor-pointer text-gray-900 hover:text-markencode-blue outline-none">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />

                  </svg>


                </div>

                <div class="grid grid-cols-3 gap-3">

                  <div v-for="partner in partners" :key="partner.id" class="flex items-center">
                    <input v-model="partner_ids" :value="partner.id" type="checkbox" :checked="partner.id == 1"
                      class="h-4 w-4 border-gray-300 text-markencode-blue focus:ring-markencode-blue">
                    <label class="ml-3 block text-sm font-medium leading-6 text-gray-900">{{ partner.name
                      }}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
export default {
  props: {
    question: Object,
    partners: Array,
  },

  data() {
    return {
      partner_ids: this.question?.partner_ids || [],
    };
  },

  watch: {
    partner_ids: {
      handler: function () {
        this.$emit('partnersChanged', this.partner_ids);
      },
    },
  },

  methods: {
    checkAllPartners() {
      // if (this.partner_ids.length === this.partner.length) {}
      this.partner_ids = [...this.partners.map(partner => partner.id)];
    },

    uncheckAllPartners() {
      this.partner_ids = [];
    },
  },
};
</script>
